import * as Sentry from "@sentry/react";

import configStore from '../../stores/ConfigStore';
import contextStore from '../../stores/ContextStore';

import tokenDataService from './TokenDataService';
import signaling from '../site/signaling';
import meetingAddonsDataService from '../api/MeetingAddonsDataService';
import addonMessanger from '../../app/workspace/AddonMessanger';


class TokenRefreshingService {

  private refreshingInterval?: number;
  private CHECK_INTERVAL_SECONDS = 10;
  private retryCounter = 0;

  public monitorAsync = async () => {
    if (this.refreshingInterval) {
      window.clearInterval(this.refreshingInterval);
    }

    // every 30 seconds check if token is about to expire in 60 seconds
    this.refreshingInterval= window.setInterval(async () => {
        if (this.isStaleToken()) {
          await this.refreshAsync();
        }
    } , this.CHECK_INTERVAL_SECONDS * 1000)
  }

  public isStaleToken = () => {
    const refreshBufferInterval = this.CHECK_INTERVAL_SECONDS * 3;
    const tokenValidity = (configStore.appToken.expireAt - Date.now()) / 1000;
    const validPeriod = tokenValidity - refreshBufferInterval
    return validPeriod < 0;
  }

  public refreshAsync = async () => {
    
    if (this.retryCounter > 5) {
      return;
    }

    const { setAddonRuntimeInfo } = contextStore!;

    
    // refresh meet app token
    try {
      const tokenInfo = await  tokenDataService.refreshTokenAsync();

      configStore.setToken({
          value: tokenInfo.access_token,
          expireAt: tokenInfo.expires_at 
      });
  
      signaling.disconnect(true);
      signaling.initAsync(true)
  
      const addonRuntimeInfos = await meetingAddonsDataService.getAddonsRuntimeInfoAsync();
      setAddonRuntimeInfo(addonRuntimeInfos);
      
      addonRuntimeInfos.forEach(addonRuntimeInfo => {
        addonMessanger.sendTokenRefreshMessage(addonRuntimeInfo)
      })
      this.retryCounter = 0;
    }
    catch (e) {
      console.error(e);
      this.retryCounter++;
      if (this.retryCounter > 5) {
        window.clearInterval(this.refreshingInterval);
        Sentry.captureException(e); 
        window.location.reload();
      }
    }
  }
}

export default new TokenRefreshingService();